import ReactPlayer from 'react-player'
import styled from 'styled-components'

import * as color from '../constants/colors'
import * as icon from '../svg/icons'

export const SizeWrapper = styled.div<{ $width: number; $height: number }>`
  max-height: ${({ $height }) => $height}px;
  max-width: ${({ $width }) => $width}px;
  width: 100%;
  height: 100%;
  transition: all 0.2s ease-in-out;
`

export const Player = styled(ReactPlayer)`
  width: 100%;
  height: 100%;
`

export const Wrapper = styled.div`
  width: min-content;
  height: min-content;
  position: relative;
  cursor: pointer;

  ${icon.Icon} {
    color: ${color.WHITE};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
